import { TR, TDT, TA } from "../../components";
import { FiEdit2 } from "react-icons/fi";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import TableContext from "../Provider/TableContext";
import useApp from "../../../../Hooks/useApp";
import { hasOtherPermission } from "../../../../Util/Permissions";

function TableRow({ doc }) {
  const { user, setShowNotAuthorized } = useApp();
  const navigate = useNavigate();
  const { setShowDeleteModal, setSystemId } = useContext(TableContext);

  function showDelete() {
    setSystemId(doc?.id);
    setShowDeleteModal(true);
  }

  function handleAuth() {
    setShowNotAuthorized(true);
  }

  return (
    <TR>
      <TDT name="Name" txt={doc?.name || "--"} />
      <TDT name="Company" txt={doc?.company || "--"} />
      <TDT name="Email" txt={doc?.email || "--"} />
      <TDT name="Phone" txt={doc?.phone || "--"} />
      <TDT name="Address" txt={doc?.address || "--"} />
      <TA name="Actions">
        <div className="flex gap-4">
          <div
            className="cursor-pointer"
            onClick={() => navigate(`edit/${doc?.id}`)}
          >
            <FiEdit2 className="text-2xl text-center" />
          </div>
          <div
            className="cursor-pointer"
            onClick={
              hasOtherPermission(user, "delete_supplier")
                ? showDelete
                : handleAuth
            }
          >
            <RiDeleteBin5Line className="text-red text-2xl text-center" />
          </div>
        </div>
      </TA>
    </TR>
  );
}

export default TableRow;
